import { useMutation } from '@apollo/client';
import {
    ModalContent,
    ModalTitle,
    PrimaryButton,
    ResponsiveSidebarDialog,
    SecondaryButton,
    StickyModalActions,
} from '@/styles/blocks';
import { css } from '@emotion/react';
import { captureException } from '@sentry/react';
import { Grid, TextField } from '@material-ui/core';
import { ADD_NOTE } from './graphql';
import { OnwardCheckbox } from '@/components/ShipmentForm/blocks';
import { startCase } from 'lodash';
import { useClientUser } from '@/hooks';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '@/components/App';

const AddNoteModal = ({ claim, open, onClose, onSave, callbacks }) => {
    const { accountType, isOnwardAdmin } = useClientUser();
    const { user } = useContext(UserContext);

    const [note, setNote] = useState('');
    const [privateNote, setPrivateNote] = useState(false);

    useEffect(() => {
        setNote('');
        setPrivateNote(false);
    }, [open]);

    const [insertNote, { loading: saveInFlight }] = useMutation(ADD_NOTE, {
        onError: (error) => {
            console.error(error);
            captureException(error);
            callbacks.setNotification({
                severity: 'error',
                message: `Failed to add note. ${error.message}`,
            });
        },
    });

    const addNote = () => {
        insertNote({
            variables: {
                note: {
                    claim_id: claim.claim_id,
                    note,
                    private_to: privateNote ? (isOnwardAdmin ? 'Admin' : startCase(accountType)) : null,
                    requires_acknowledgement: true,
                    source_user_id: user.user_id,
                    source_user_type: isOnwardAdmin ? 'Admin' : startCase(accountType),
                },
            },
        }).then(() => {
            onSave();
        });
    };

    return (
        <ResponsiveSidebarDialog open={open} onClose={onClose}>
            <ModalTitle title={'Add Note'} onClose={onClose} />
            <ModalContent
                css={css`
                    width: 600px;
                `}
            >
                <Grid container direction="column" css={css``}>
                    <Grid
                        item
                        css={css`
                            margin-bottom: 1rem;
                        `}
                    >
                        <TextField
                            variant="outlined"
                            label="Note"
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                            multiline
                            minRows={3}
                            maxRows={10}
                            fullWidth
                        />
                    </Grid>
                    <Grid item>
                        <OnwardCheckbox
                            label="Private Note"
                            checked={privateNote}
                            onChange={(e) => setPrivateNote(e.target.checked)}
                        />
                    </Grid>
                </Grid>
            </ModalContent>
            <StickyModalActions>
                <Grid item>
                    <SecondaryButton disabled={saveInFlight} onClick={onClose}>
                        Cancel
                    </SecondaryButton>
                </Grid>
                <Grid item>
                    <PrimaryButton disabled={saveInFlight} onClick={addNote}>
                        Create
                    </PrimaryButton>
                </Grid>
            </StickyModalActions>
        </ResponsiveSidebarDialog>
    );
};

export default AddNoteModal;
